<button mdbBtn type="button" [color]="color" (click)="onClick()" mdbWavesEffect [disabled]="processing || disabled"
  class="btn-sm api_button" size="sm">
  <div *ngIf="processing" class="spinner-border spinner-border-sm" style="margin-right: 5px;" role="status">
  </div>
  <!-- <div *ngIf="processing" class="spinner-grow spinner-grow-sm" style="margin-right: 5px;" role="status">
    </div> -->
  <ng-content></ng-content>
</button>